import { CALENDAR_LOCALE } from '../../services/constant';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../services/alert.service';
var AbbDashboardComponent = (function () {
    function AbbDashboardComponent(alertService, apiService, modalService, router, translateService) {
        this.alertService = alertService;
        this.apiService = apiService;
        this.modalService = modalService;
        this.router = router;
        this.translateService = translateService;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading = false;
        this.totalItems = 0;
        this.tableData = [];
        this.selectedValues = [];
        this.allChecked = false;
    }
    AbbDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translateService.onLangChange.subscribe(function () {
            _this.loadInput();
            _this.search();
        });
        this.loadInput();
        this.search();
    };
    AbbDashboardComponent.prototype.loadInput = function () {
        this.calendarLocale = this.translateService.currentLang === 'en'
            ? CALENDAR_LOCALE.EN
            : CALENDAR_LOCALE.TH;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    Object.defineProperty(AbbDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbbDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    AbbDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    AbbDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    AbbDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    AbbDashboardComponent.prototype.search = function (resetPageNumber) {
        var _this = this;
        if (resetPageNumber === void 0) { resetPageNumber = true; }
        if (resetPageNumber) {
            this.currentPage = 1;
        }
        var params = {
            abb_no: this.abbNo || '',
            outlet: this.outlet || '',
            issue_dt_after: moment(this.startDate).format('YYYY-MM-DD'),
            issue_dt_before: moment(this.endDate).format('YYYY-MM-DD'),
            page: this.currentPage,
            page_size: this.itemsPerPage,
        };
        this.loading = true;
        this.apiService.getAbbData(params).subscribe(function (response) {
            _this.loading = false;
            _this.tableData = response.results;
            _this.totalItems = response.count;
            _this.selectedValues = Array(_this.tableData.length).fill(false);
        }, function (error) {
            _this.loading = false;
            console.error(error);
        });
    };
    AbbDashboardComponent.prototype.clear = function () {
        this.abbNo = null;
        this.outlet = null;
        this.loadInput();
        this.search();
    };
    AbbDashboardComponent.prototype.pageChanged = function () {
        this.search(false);
        this.allChecked = false;
    };
    AbbDashboardComponent.prototype.optionChanged = function () {
        this.search();
    };
    AbbDashboardComponent.prototype.gotoDocumentIssue = function (data) {
        this.router.navigate(['document', 'issue'], { queryParams: { abbData: data.id } });
    };
    AbbDashboardComponent.prototype.selectDeselectAll = function (checked) {
        this.selectedValues = Array(this.tableData.length).fill(checked);
        this.allChecked = checked;
    };
    AbbDashboardComponent.prototype.isAllSelect = function () {
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i]) {
                this.allChecked = false;
                return;
            }
        }
        this.allChecked = true;
    };
    AbbDashboardComponent.prototype.getSelectId = function () {
        var selectedId = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                selectedId.push(this.tableData[i].id);
            }
        }
        return selectedId.join(',');
    };
    AbbDashboardComponent.prototype.getExportExcel = function () {
        var _this = this;
        var params = {
            search_box: this.getSelectId(),
        };
        this.apiService.getAbbExcel(params).subscribe(function (obj) {
            var currentDate = moment().format('DD-MM-YYYY');
            var filename = currentDate + "_abb_export.xlsx";
            _this.apiService.createDownloadFile(obj, filename);
        });
    };
    AbbDashboardComponent.prototype.openConfirmationModal = function (content, data) {
        var _this = this;
        this.modal = this.modalService.open(content, { backdrop: 'static', centered: true });
        this.modal.result.then(function (result) {
            if (!result) {
                return;
            }
            _this.apiService.deleteAbbData(data.id).subscribe(function () {
                _this.alertService.toastNotify({
                    type: 'success',
                    text: _this.translateService.instant('COMMON.SUCCESS-DELETE'),
                    timer: 2000,
                });
                _this.search();
            }, function (err) {
                _this.alertService.toastNotify({
                    type: 'error',
                    text: _this.translateService.instant('ERROR.TRY-AGAIN'),
                    timer: 2000,
                });
            });
        });
    };
    AbbDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
        if (this.modal) {
            this.modal.close();
        }
    };
    return AbbDashboardComponent;
}());
export { AbbDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.component.ts.pre-build-optimizer.js